import {
  Component,
  ContentChildren,
  HostBinding,
  Input,
  NgZone,
  OnInit,
  Optional,
  QueryList,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';

import { delay, filter, startWith, switchMap, tap } from 'rxjs/operators';

import { TypedFormBuilder } from 'projects/zalamo-library/src/lib/ui/form/TypedFormBuilder';
import { UntypedFormControl, NgControl } from '@angular/forms';
import { AbstractValueAccessor } from 'ZalamoLibrary/src/lib/core/form/FormControl';
import { ImageListOptionComponent } from 'ZalamoLibrary/src/lib/ui/form/image-list-picker/image-list-option/image-list-option.component';

@Component({
    selector: 'lib-image-list-picker',
    templateUrl: './image-list-picker.component.html',
    styleUrls: ['./image-list-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImageListPickerComponent
  extends AbstractValueAccessor
  implements OnInit
{
  control = new UntypedFormControl();
  @ContentChildren(ImageListOptionComponent, { descendants: true })
  options: QueryList<ImageListOptionComponent>;
  @Input() @HostBinding('class.center') center = false;
  constructor(
    private fb: TypedFormBuilder,
    @Self() @Optional() public ngControl: NgControl,
    private _ngZone: NgZone,
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngAfterContentInit() {
    // We need this to run before the `changes` subscription in parent to ensure that the
    // selectedIndex is up-to-date by the time the super class starts looking for it.
    this.options.changes.pipe(startWith([]), delay(0)).subscribe((r) => {
      this.updateSelection(this.control.value);
    });
  }

  updateSelection(current) {
    console.log('CURRENT MODE', current);
    if (this.options) {
      this.options.toArray().forEach((value) => (value.selected = false));
      const currentIndex = this.options
        .toArray()
        .findIndex(({ value }) => value === current);
      if (!!this.options.toArray()[currentIndex]) {
        this.options.toArray()[currentIndex].selected = true;
      }
    }
  }

  ngOnInit(): void {
    let updateInProgress = false;
    this.subscribeWhileAlive(
      this.ngOnChanges$.pipe(
        switchMap(() =>
          this.valueSubject.pipe(tap((v) => this.updateSelection(v))),
        ),
      ),
      this.valueSubject.pipe(
        filter(() => !updateInProgress),
        tap((current) => this.updateSelection(current)),
        tap((current) => {
          updateInProgress = true;
          this.control.patchValue(current, { emitEvent: false });
          updateInProgress = false;
        }),
      ),
      this.control.valueChanges.pipe(
        filter(() => !updateInProgress),
        tap((current) => {
          this.updateSelection(current);
          updateInProgress = true;
          this.writeValue(current);
          updateInProgress = false;
        }),
      ),
    );
  }
}
